// statusUtils.js - Durum renkleri için ortak yardımcı dosya

/**
 * Durum ismini ve rengini kullanarak uygun CSS sınıfını döndürür
 * @param {string} status - Durum ismi
 * @param {string} color - Durum rengi (hex, rgb, vb.)
 * @returns {string} CSS sınıfı
 */
export const getStatusClass = (status, color) => {
  if (!status) return 'bg-gray-100 text-gray-800';
  
  // Eğer özel bir renk tanımlanmışsa, o rengi kullan
  if (color && color.startsWith('#')) {
    // Tailwind CSS kullanılmıyor, doğrudan renk sınıfları döndürüyoruz
    return `status-custom-color`;
  }
  
  // Özel bir renk yoksa, durum adına göre varsayılan renkler
  const lowerStatus = status.toLowerCase();
  
  if (lowerStatus.includes('onayla') || lowerStatus.includes('tamamla') || lowerStatus.includes('edildi')) {
    return 'bg-green-100 text-green-800';
  }
  
  if (lowerStatus.includes('red') || lowerStatus.includes('iptal')) {
    return 'bg-red-100 text-red-800';
  }
  
  if (lowerStatus.includes('incele') || lowerStatus.includes('işlem')) {
    return 'bg-blue-100 text-blue-800';
  }
  
  if (lowerStatus.includes('bekle')) {
    return 'bg-yellow-100 text-yellow-800';
  }
  
  return 'bg-gray-100 text-gray-800';
};

/**
 * Hex renk kodunu RGBA'ya dönüştürme
 * @param {string} hex - Hex renk kodu
 * @param {number} opacity - Opaklık değeri (0-1 arası)
 * @returns {string} RGBA renk kodu
 */
export const hexToRgba = (hex, opacity = 1) => {
  if (!hex || !hex.startsWith('#')) return '';
  
  // Hex renk kodunu RGB'ye dönüştür
  let r = 0, g = 0, b = 0;
  
  // #RRGGBB formatı
  if (hex.length === 7) {
    r = parseInt(hex.substring(1, 3), 16);
    g = parseInt(hex.substring(3, 5), 16);
    b = parseInt(hex.substring(5, 7), 16);
  } 
  // #RGB formatı
  else if (hex.length === 4) {
    r = parseInt(hex.substring(1, 2), 16) * 17;
    g = parseInt(hex.substring(2, 3), 16) * 17;
    b = parseInt(hex.substring(3, 4), 16) * 17;
  }
  
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/**
 * Durum için stil nesnesi oluşturur
 * @param {string} color - Hex renk kodu
 * @returns {Object} Stil nesnesi
 */
export const getStatusStyle = (color) => {
  if (!color || !color.startsWith('#')) return {};
  
  return {
    backgroundColor: hexToRgba(color, 0.2),
    color: color
  };
}; 